/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RenditionsControllerFindAllQueryResponse, RenditionsControllerFindAllPathParams, RenditionsControllerFindAllQueryParams, RenditionsControllerFindAll401, RenditionsControllerFindAll403 } from "../../models/documentRenditionsController/RenditionsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { renditionsControllerFindAll } from "../../clients/document-renditionsService/renditionsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const renditionsControllerFindAllQueryKey = (documentId: RenditionsControllerFindAllPathParams["documentId"], params: RenditionsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions',
  params: {
    documentId: documentId
  }
}, ...(params ? [params] : [])] as const;
export type RenditionsControllerFindAllQueryKey = ReturnType<typeof renditionsControllerFindAllQueryKey>;
export function renditionsControllerFindAllQueryOptions(documentId: RenditionsControllerFindAllPathParams["documentId"], params?: RenditionsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = renditionsControllerFindAllQueryKey(documentId, params);
  return queryOptions<RenditionsControllerFindAllQueryResponse, ResponseErrorConfig<RenditionsControllerFindAll401 | RenditionsControllerFindAll403>, RenditionsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!documentId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return renditionsControllerFindAll(documentId, params, config);
    }
  });
}

/**
 * @description Returns renditions with JSON:API pagination, sorting, and filtering
 * @summary List renditions for a document
 * {@link /api/v1/documents/:documentId/renditions}
 */
export function useRenditionsControllerFindAll<TData = RenditionsControllerFindAllQueryResponse, TQueryData = RenditionsControllerFindAllQueryResponse, TQueryKey extends QueryKey = RenditionsControllerFindAllQueryKey>(documentId: RenditionsControllerFindAllPathParams["documentId"], params?: RenditionsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<RenditionsControllerFindAllQueryResponse, ResponseErrorConfig<RenditionsControllerFindAll401 | RenditionsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? renditionsControllerFindAllQueryKey(documentId, params);
  const query = useQuery({
    ...renditionsControllerFindAllQueryOptions(documentId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RenditionsControllerFindAll401 | RenditionsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}